import { Component, OnInit, Input, Output, EventEmitter, ViewChildren,
	ViewChild, ElementRef, Renderer } from '@angular/core';

import { Observable, Subscription } from 'rxjs/';

declare var $:any;
@Component({
	selector: 'itpx-rating',
	templateUrl: './rating.component.html',
	styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {

	@Input() ratingValue:number;
	@Input() max:number;
	@Input() readonly:boolean;
	@Input() starSize:string;
	@Input() color:string;
	@Input() fillColor:string;
	@Input() refreshTooltip: Observable<any>;
	@Input() tooltipRatingScale: Array<string>;
	@Output() onMouseOver = new EventEmitter();
	@Output() ratingValueChange:EventEmitter<number> = new EventEmitter<number>();
	@Output() onRatingChanged = new EventEmitter();
	@ViewChildren('starFilled') starChildren;
	@ViewChild('tooltip') tooltip;

	public stars = [];
	private ele:ElementRef;
	private render:Renderer;
	private changeElements:HTMLElement[]

	constructor(
		private e1:ElementRef,
		render:Renderer, 
		private el: ElementRef) { 
		this.ele = e1;
		this.render = render;
	}

	ngOnInit() {
		this.fillColor = this.fillColor || 'gold';
	}

	public ngOnChanges(){ 
		
        if (this.readonly == undefined){
            this.readonly = false;
        };    
        if (typeof(this.readonly)=='string'){    
          this.readonly = (String(this.readonly)=='true');    
        }
		this.updateStars();
		
		if(this.tooltip) {
			$(this.tooltip.nativeElement).popover();
		}

    }

    public ngAfterViewInit(){

		let elementIndexList = $('[data-index]');
		let contentList = this.tooltipRatingScale; 
		if(contentList) {
			elementIndexList.each(function(index){
				let content;
				contentList.forEach(el => {
					if (contentList.indexOf(el) == index) {
						return content = el
					}
				})
				$(this).attr('data-content', content)
			})
		}
		
		$('[data-toggle="popover"]').popover({
			container: 'body'
		});

		$('[data-toggle="popover"]').popover(); 
        this.starChildren.changes.subscribe(changes=>
        {   
            this.changeElements = changes._results.map(
                (eleRef)=> eleRef.nativeElement
                );

            this.onRatingChanged.next(
                {  ratingValue: this.ratingValue,
                    max: this.max,
                    changedElements: this.changeElements
                });           
        });  
    }

    public onMouseEnter(evt){  
        this.onMouseOver.next(evt);
    }

    public ngAfterViewChecked(){
            
    }

	public ngAfterContentInit(){
	
	}

	private updateStars(){
		this.stars = [];    
		let j = this.max - this.ratingValue;

		for (let i = 1; i <= this.max; i++) {                                  
				this.stars.push({ filled: i > j });         
			}
		this.render.setElementStyle(this.ele.nativeElement,'color', this.color);
	}

	private toggle(index){     
		$('[data-index='+ index + ']').popover('hide');
		if (this.readonly===false){
			this.ratingValue =  (this.max - index);
			this.updateStars(); 
			this.ratingValueChange.emit(this.ratingValue);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/rating/rating.component.ts